import details from './details';

export const owner = {
  ...details,
};
